import type {
  TransportationMode,
  TransportationModeApi,
  TransportationModeFilters,
  TransportationModeFiltersUpdateApi,
  TransportationModes,
  TransportationModesApi,
} from '../../models';
import { inlineSearch, paginate } from '../normalize';

export const normalizeTransportationMode = (transportationMode: TransportationModeApi): TransportationMode => ({
  ...transportationMode,
  id: transportationMode.codeId ?? String(transportationMode.id),
  label: transportationMode.codeDesc,
});

export const normalizeTransportationModes = (response: TransportationModesApi): TransportationModes => {
  const list = (response.items ?? [])
    .sort((a, b) => a.codeDesc.localeCompare(b.codeDesc))
    .map(normalizeTransportationMode);

  return {
    list,
    map: list.reduce(
      (acc, transportationMode) => {
        acc[String(transportationMode.id)] = transportationMode;
        return acc;
      },
      {} as TransportationModes['map'],
    ),
  };
};

export const normalizeTransportationModeFilters = (
  filters: Partial<TransportationModeFilters>,
): TransportationModeFiltersUpdateApi => {
  const { search, ...otherFilters } = filters;
  return {
    ...inlineSearch(search),
    ...inlineSearch(otherFilters),
    ...paginate(otherFilters),
    Sorting: 'codeDesc asc',
  };
};
